export const MAX_TEXT_LENGTH = 255;

export const sanitizeTextInput = (value?: string): string => {
  if (!value) {
    return "";
  }

  return value
    .replace(/<[^>]*>/g, "")
    .replace(/[\u0000-\u001F\u007F]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, MAX_TEXT_LENGTH);
};

export const sanitizeCurrencyInput = (value?: string): string => {
  if (!value) {
    return "";
  }

  return value.replace(/\D/g, "");
};

export const formatCurrencyDisplay = (value?: string): string => {
  const numericValue = sanitizeCurrencyInput(value);

  if (!numericValue) {
    return "";
  }

  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
